import { useLocation } from 'react-router-dom';

const SITE_NAME = 'Book Cloud';
const DEFAULT_DESC = 'BookCloud — the e-book website to buy, read, and publish books online. A modern digital bookstore with thousands of titles from bestselling and independent authors.';
const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://bookcloud.in';

// React 19 hoists <title>/<meta> rendered anywhere into <head>, so this
// component needs no portal or helmet dependency.
export default function Seo({ title, description, image, noIndex }) {
  const { pathname } = useLocation();
  const fullTitle = title ? `${title} · ${SITE_NAME}` : `${SITE_NAME} — Digital Bookstore`;
  const desc = description || DEFAULT_DESC;
  const url = `${SITE_URL}${pathname}`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}

      <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
    </>
  );
}
